import React from 'react'
import { userDeviceDetect } from 'utils'
import { CustomModal } from 'redesign/components/atoms/CustomModal'
import { BottomSheet } from 'components'
import { BottomSheetWrapper, BottomSheetTitle, BottomSheetContent, BottomSheetButtonWrapper } from '../SignUpModal/styles'
import { Button } from '@dasa-health/components-react'

type CustonModalOrBootomSheetProps = {
    title: string
    children: React.ReactNode
    showModal: boolean
    setShowModal: (b: boolean) => void
    showCloseButtonModal?: boolean
    showBackButtonBottomSheet?: boolean
}

export const CustonModalOrBootomSheet = ({
    children,
    setShowModal,
    showModal,
    title,
    showCloseButtonModal = true,
    showBackButtonBottomSheet = true,
}: CustonModalOrBootomSheetProps) => {
    const { isPortable } = userDeviceDetect()

    return (
        <>
            {showModal && !isPortable && (
                <CustomModal
                    onClose={() => {
                        setShowModal(false)
                        sessionStorage.removeItem('@redirectToUrl')
                    }}
                    open={showModal}
                    showCloseButton={showCloseButtonModal}
                    title={title}
                >
                    {children}
                </CustomModal>
            )}

            {showModal && isPortable && (
                <BottomSheet isOpen={showModal} onRequestClose={() => setShowModal(!showModal)}>
                    <BottomSheetWrapper>
                        {title && <BottomSheetTitle>{title}</BottomSheetTitle>}
                        <BottomSheetContent>{children}</BottomSheetContent>
                        {showBackButtonBottomSheet && (
                            <BottomSheetButtonWrapper>
                                <Button onClick={() => setShowModal(false)} type="button" variant="tertiary">
                                    Voltar
                                </Button>
                            </BottomSheetButtonWrapper>
                        )}
                    </BottomSheetWrapper>
                </BottomSheet>
            )}
        </>
    )
}
